import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_ORDER } from './consts.js';

function FormInline(props){
  const {title, className, button} = props;
  const [errors, setErrors] = useState({'phone': null, 'email': null, 'name': null});
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [confirm, setConfirm] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      name,
      phone,
      email,
      confirm,
    };

    try {
      const response = await axios.post(API_ORDER, formData);
      console.log(response.data);
      setErrors({
          name: null, 
          phone: null, 
          email: null,
          confirm: null,
      })
      navigate(`/thanks?name=${name}`);
      window.location.replace(`/thanks?name=${name}`); 
    } catch (error) {
      console.error('There was an error!', error);
      setErrors({
        name: (error.response.data['name']) ? error.response.data['name'][0]: null, 
        phone: (error.response.data['phone']) ? error.response.data['phone'][0]: null, 
        email: (error.response.data['email']) ? error.response.data['email'][0]: null,
        confirm: (error.response.data['confirm']) ? error.response.data['confirm'][0]: null
      })
    }
  };
  return (
    <form onSubmit={handleSubmit}
      className={className || "stat__form form"}
      data-aos="fade-right"
    >
    <h3 className="form__title">
      {title}
    </h3>
    <div className="form__row gap">
      <div>
        <fieldset className="form__group">
          <label className={`form__field form-field ${(errors['name']) ? 'error': ''}`}>
            <input
              className="form-field__input"
              type="text"
              data-validate-field="name"
              placeholder="Имя и фамилия"
              name="Имя"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <div className='error-block'>{errors.name}</div>
          </label>
          <label className={`form__field form-field ${(errors['phone']) ? 'error': ''}`}>
            <input
              className="form-field__input"
              type="tel"
              data-validate-field="tel"
              placeholder="+7(___)-___-__-__"
              name="Телефон"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <div className='error-block'>{errors.phone}</div>
          </label>
          <label className={`form__field form-field ${(errors['email']) ? 'error': ''}`}>
            <input
              className="form-field__input"
              type="email"
              data-validate-field="email"
              placeholder="bestpartner@topkids-center.ru"
              name="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className='error-block'>{errors.email}</div>
          </label>
        </fieldset>
        <div className="form-block-police">
          <label className={`checkbox ${(errors['confirm']) ? 'error': ''}`} htmlFor="confirm">
            <input 
              type="checkbox" 
              className="checkbox" 
              name="confirm" 
              id="confirm" 
              aria-invalid="false" 
              value={confirm}
              onChange={(e) => setConfirm(!confirm)}
            />
            <div>Я ознакомлен и согласен на обработку персональных данных на условиях и для целей, определяемых <button data-hystmodal="#policy" class="btn-reset">Политикой конфиденциальности.</button>
            </div>
            </label>
        </div>
      </div>
      <button className="form__btn btn-reset btn" type="submit">
        {button || 'Получить информацию'}
      </button>
    </div>
  </form>
  );
};

export default FormInline;